import { ASSET_STATUS, LOANER_STATUS } from '../../../config';
import { formatDate } from '../../../utils/dateTimeFns';

function transposeDate(inputDate) {
  return formatDate(inputDate, true);
}

export const formatExpandedData = (device, labels) => {
  const expandedDataL = [
    {
      label:
        labels[
          'labels.clinicEquipment.dataTable.columns.productFamily'
        ],
      value: device?.product?.family,
    },
    {
      label:
        labels[
          'labels.clinicEquipment.dataTable.columns.currentlyWith'
        ],
      value: device?.currentlyWith || '-',
    },
  ];

  const expandedDataR = [];

  if (device?.status === ASSET_STATUS.Loaner) {
    expandedDataR.push({
      label:
        labels['labels.clinicEquipment.dataTable.columns.srNumber'],
      value: device?.serviceRequest?.number || '-',
    });
  }

  if (
    device?.status === ASSET_STATUS.Loaner &&
    device?.loanerStatus !== LOANER_STATUS.LoanerWithClinic
  ) {
    expandedDataR.unshift(
      {
        label:
          labels[
            'labels.clinicEquipment.dataTable.columns.loanerStatus'
          ],
        value:
          labels[
            `labels.clinicEquipment.loanerStatus.${device?.loanerStatus}`
          ] ||
          device?.loanerStatus ||
          '-',
      },
      {
        label:
          labels[
            'labels.clinicEquipment.dataTable.columns.loanedDate'
          ],
        value: transposeDate(device?.startDate),
      },
    );
  }

  if (
    [
      LOANER_STATUS.LoanerReturnRecommended,
      LOANER_STATUS.LoanerReturnCritical,
    ].includes(device?.loanerStatus)
  ) {
    expandedDataR.push({
      label:
        labels[
          'labels.clinicEquipment.dataTable.columns.srClosedDate'
        ],
      value: transposeDate(device?.serviceRequest?.endDate),
    });
  }

  return {
    expandedDataL,
    expandedDataR,
  };
};
